(() => {
  const initContactPremium = (section) => {
    if (!section || section.dataset.cpReady === 'true') return;
    section.dataset.cpReady = 'true';

    const form = section.querySelector('[data-cp-form]');
    const store = section.querySelector('[data-cp-store]');
    const priority = section.querySelector('[data-cp-priority]');
    const details = section.querySelector('[data-cp-details]');
    const name = section.querySelector('[data-cp-name]');
    const email = section.querySelector('[data-cp-email]');
    const deadline = section.querySelector('[data-cp-deadline]');
    const budget = section.querySelector('[data-cp-budget]');
    const nextButton = section.querySelector('[data-cp-next]');
    const backButton = section.querySelector('[data-cp-back]');
    const submitButton = section.querySelector('[data-cp-submit]');
    const storeError = section.querySelector('[data-cp-store-error]');
    const priorityError = section.querySelector('[data-cp-priority-error]');
    const emailError = section.querySelector('[data-cp-email-error]');
    const hiddenBody = section.querySelector('[data-cp-hidden-body]');
    const panels = [...section.querySelectorAll('[data-cp-step]')];
    const progress = [...section.querySelectorAll('[data-cp-progress]')];
    const stepLabel = section.querySelector('[data-cp-step-label]');
    let currentStep = 1;

    const storeIsValid = (showError = false) => {
      if (!store) return false;
      const valid = store.value.trim() !== '' && store.validity.valid;
      store.setAttribute('aria-invalid', String(!valid && (showError || store.value !== '')));
      if (storeError) storeError.hidden = valid || (!showError && store.value === '');
      return valid;
    };

    const priorityIsValid = (showError = false) => {
      if (!priority) return false;
      const valid = priority.value !== '';
      priority.setAttribute('aria-invalid', String(!valid && showError));
      if (priorityError) priorityError.hidden = valid || !showError;
      return valid;
    };

    const nameIsValid = () => Boolean(name?.value.trim());

    const emailIsValid = (showError = false) => {
      if (!email) return false;
      const valid = email.value.trim() !== '' && email.validity.valid;
      email.setAttribute('aria-invalid', String(!valid && (showError || email.value !== '')));
      if (emailError) emailError.hidden = valid || (!showError && email.value === '');
      return valid;
    };

    const updateButtons = () => {
      if (nextButton) nextButton.disabled = !(storeIsValid(false) && priorityIsValid(false));
      if (submitButton) submitButton.disabled = !(nameIsValid() && emailIsValid(false));
    };

    const setStep = (step, focus = true) => {
      currentStep = step === 2 ? 2 : 1;
      panels.forEach((panel) => { panel.hidden = Number(panel.dataset.cpStep) !== currentStep; });
      progress.forEach((marker) => {
        const markerStep = Number(marker.dataset.cpProgress);
        marker.classList.toggle('is-active', markerStep === currentStep);
        marker.classList.toggle('is-complete', markerStep < currentStep);
        if (markerStep === currentStep) marker.setAttribute('aria-current', 'step');
        else marker.removeAttribute('aria-current');
      });
      if (stepLabel) stepLabel.textContent = `Étape ${currentStep} sur 2`;
      updateButtons();
      if (focus) window.setTimeout(() => (currentStep === 1 ? store : name)?.focus(), 80);
    };

    store?.addEventListener('input', updateButtons);
    store?.addEventListener('blur', () => storeIsValid(store.value !== ''));
    priority?.addEventListener('change', updateButtons);
    name?.addEventListener('input', updateButtons);
    email?.addEventListener('input', updateButtons);
    email?.addEventListener('blur', () => emailIsValid(email.value !== ''));
    nextButton?.addEventListener('click', () => {
      const validStore = storeIsValid(true);
      const validPriority = priorityIsValid(true);
      if (validStore && validPriority) setStep(2);
      else (validStore ? priority : store)?.focus();
    });
    backButton?.addEventListener('click', () => setStep(1));

    form?.addEventListener('submit', (event) => {
      const validStore = storeIsValid(true);
      const validPriority = priorityIsValid(true);
      const validName = nameIsValid();
      const validEmail = emailIsValid(true);
      if (!validStore || !validPriority || !validName || !validEmail) {
        event.preventDefault();
        setStep(validStore && validPriority ? 2 : 1);
        return;
      }
      if (hiddenBody) {
        hiddenBody.value = [
          `Boutique : ${store.value}`,
          `Priorité : ${priority.value}`,
          `Contexte : ${details?.value.trim() || 'Non précisé'}`,
          `Échéance : ${deadline?.value || 'À définir'}`,
          `Budget indicatif : ${budget?.value || 'Non défini'}`,
          'Source : page contact EXPERAISE',
          `Page : ${window.location.pathname}`
        ].join('\n');
      }
      if (submitButton) {
        submitButton.disabled = true;
        const label = submitButton.querySelector('span');
        if (label) label.textContent = 'Envoi en cours…';
      }
    });

    if (section.querySelector('[data-cp-success]')) section.querySelector('[data-cp-success]').focus();
    else setStep(section.querySelector('[data-cp-server-errors]') ? 2 : 1, false);

    const portfolio = section.querySelector('[data-cp-portfolio]');
    const viewport = section.querySelector('[data-cp-viewport]');
    const slides = [...section.querySelectorAll('[data-cp-slide]')];
    const previous = section.querySelector('[data-cp-prev]');
    const next = section.querySelector('[data-cp-next-slide]');
    const status = section.querySelector('[data-cp-slide-status]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let slideIndex = 0;
    let autoplay = null;
    let pointerStart = null;

    const showSlide = (index) => {
      if (!slides.length) return;
      slideIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        const active = position === slideIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      if (status) status.textContent = `${slideIndex + 1} / ${slides.length} · ${slides[slideIndex].dataset.brand || 'Projet Shopify'}`;
    };

    const stopAutoplay = () => {
      if (autoplay) window.clearInterval(autoplay);
      autoplay = null;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (!reduceMotion && slides.length > 1) autoplay = window.setInterval(() => showSlide(slideIndex + 1), 5600);
    };

    previous?.addEventListener('click', () => { showSlide(slideIndex - 1); startAutoplay(); });
    next?.addEventListener('click', () => { showSlide(slideIndex + 1); startAutoplay(); });
    viewport?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      showSlide(slideIndex + (event.key === 'ArrowRight' ? 1 : -1));
      startAutoplay();
    });
    viewport?.addEventListener('pointerdown', (event) => { pointerStart = event.clientX; });
    viewport?.addEventListener('pointerup', (event) => {
      if (pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) < 45) return;
      showSlide(slideIndex + (distance < 0 ? 1 : -1));
      startAutoplay();
    });
    viewport?.addEventListener('pointercancel', () => { pointerStart = null; });
    portfolio?.addEventListener('mouseenter', stopAutoplay);
    portfolio?.addEventListener('mouseleave', startAutoplay);
    portfolio?.addEventListener('focusin', stopAutoplay);
    portfolio?.addEventListener('focusout', startAutoplay);
    showSlide(0);
    startAutoplay();
    section.addEventListener('shopify:section:unload', stopAutoplay, { once: true });
  };

  const boot = (root = document) => root.querySelectorAll('[data-contact-premium]').forEach(initContactPremium);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
